import { getEventStreamPlugin } from "@aws-sdk/middleware-eventstream";
import { getWebSocketPlugin } from "@aws-sdk/middleware-websocket";
import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { StartStreamTranscriptionRequestFilterSensitiveLog, StartStreamTranscriptionResponseFilterSensitiveLog, } from "../models/models_0";
import { de_StartStreamTranscriptionCommand, se_StartStreamTranscriptionCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class StartStreamTranscriptionCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
        getEventStreamPlugin(config),
        getWebSocketPlugin(config, { headerPrefix: "x-amzn-transcribe-" }),
    ];
})
    .s("Transcribe", "StartStreamTranscription", {
    eventStream: {
        input: true,
        output: true,
    },
})
    .n("TranscribeStreamingClient", "StartStreamTranscriptionCommand")
    .f(StartStreamTranscriptionRequestFilterSensitiveLog, StartStreamTranscriptionResponseFilterSensitiveLog)
    .ser(se_StartStreamTranscriptionCommand)
    .de(de_StartStreamTranscriptionCommand)
    .build() {
}
